module.exports = __webpack_public_path__ + "static/media/icon_33.a078fab3.svg";